import { render } from "./GiftShopNav.vue?vue&type=template&id=dd90771e"
import script from "./GiftShopNav.vue?vue&type=script&lang=js"
export * from "./GiftShopNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__